export const LOAD_GLOBAL_PARAMS_STARTED = "LOAD_GLOBAL_PARAMS_STARTED";
export const LOAD_GLOBAL_PARAMS_SUCCESS = "LOAD_GLOBAL_PARAMS_SUCCESS";
export const SAVE_GLOBAL_PARAMS_STARTED = "SAVE_GLOBAL_PARAMS_STARTED";
export const SAVE_GLOBAL_PARAMS_SUCCESS = "SAVE_GLOBAL_PARAMS_SUCCESS";
